import React, { useEffect, useState } from 'react';
import tw from 'twin.macro';
import { useParams } from 'react-router-dom';
import { Container, ContentWithPaddingXl } from 'components/misc/Layouts';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Pack from 'components/cards/Pack';
import { obtenerPack } from 'scripts/obtenerPack';
import { toast } from 'react-toastify';
import Spinner from 'components/Spinner';

const StableContent = tw.div`min-h-[60vh]`;

const PaginaPack = () => {
	const { id } = useParams();
	const [pack, setPack] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const cargarPack = async () => {
			try {
				const packData = await obtenerPack(id);
				setPack(packData);
			} catch (error) {
				console.error('Error al cargar pack:', error);
				toast.error('Error al cargar el pack');
			} finally {
				setLoading(false);
			}
		};

		if (id) {
			cargarPack();
		}
	}, [id]);

	return (
		<AnimationRevealPage>
			<Container>
				<ContentWithPaddingXl>
					<StableContent>
						{loading ? (
							<Spinner text="Cargando pack..." />
						) : !pack ? (
							<p>Pack no encontrado</p>
						) : (
							<Pack pack={pack} />
						)}
					</StableContent>
				</ContentWithPaddingXl>
			</Container>
		</AnimationRevealPage>
	);
};

export default PaginaPack;
